import { PMCategoryProgressCard } from "@pimo/pimo-components/src/lib/pm-components";

import { DashboardCardContext } from "../context";

export function addCompletedItemsPerCategoryCard(ctx: DashboardCardContext) {
  const { view, getCardCopy } = ctx;

  const completedItemsPerCategoryComponent = view.addComponent({
    component: PMCategoryProgressCard,
    layoutProps: {
      componentId: "completedItemsPerCategoryComponent",
      title: "",
      description: "",
      labels: ["progress"],
    },
  });

  completedItemsPerCategoryComponent.mapLayoutProps(
    ({ language, settings }) => {
      const currentLanguage = language || "en";
      const categoryLabel = settings?.configuration?.fieldsDefinition?.find(
        (field) => field.fieldName === "category"
      )?.label;
      const copy = getCardCopy(currentLanguage, "completedItemsByCategory", {
        categoryLabel,
      });

      return {
        componentId: "completedItemsPerCategoryComponent",
        title: copy.title,
        description: copy.description,
        labels: ["progress"],
      };
    }
  );

  completedItemsPerCategoryComponent.mapState(
    ({ dashboard, settings, language }) => {
      const currentLanguage = language || "en";
      const categoryLabel = settings?.configuration?.fieldsDefinition?.find(
        (field) => field.fieldName === "category"
      )?.label;
      const copy = getCardCopy(currentLanguage, "completedItemsByCategory", {
        categoryLabel,
      });
      const existingCategories =
        settings?.configuration?.categoryDefinition?.map((cat) => cat.name) ??
        [];

      return {
        label: "Completed Items Category",
        title: copy.title,
        icon: "BarChart",
        showInfoIcon: false,
        showMenuIcon: false,
        data: existingCategories.map((category) => {
          const completed =
            dashboard?._calculated?.categoryCountsForCompletedItems?.find(
              (catCount) => catCount.label === category
            )?.value ?? 0;
          const total =
            dashboard?.projects
              ?.filter((p) => p.category === category)
              .flatMap((p) => p.reportingItems ?? []).length ?? 0;
          return {
            label: category,
            value: completed,
            total,
            color: "#38BDF8",
          };
        }),
      };
    }
  );

  completedItemsPerCategoryComponent.mapVisibility(
    ({ settings }) =>
      settings?.configuration?.fieldsDefinition
        ?.filter((field) => field.purpose === "projectBasic")
        .find((field) => field.fieldName === "category")?.enabled === true
  );
}
